// Central branding config for THE WOODLAND ERP.
// Update these values here to change branding across the entire app.
export const BRAND = {
  name: "THE WOODLAND",
  shortName: "THE WOODLAND",
  tagline: "Architecture • Interiors • Construction",
  logoUrl:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_repo-digest-9/artifacts/awq0wmdy_company%20logo.jpeg",
  address: "56, N.S Road, Subhasally, Siliguri, PIN 734005",
  phone: "9474458544",
  email: "thewoodlandinterior@gmail.com",
  website: "https://www.thewoodland.in/",
};

export const BRAND_ACCENT = "#8DC63F"; // green from the logo
export const BRAND_INK = "#1A1918";
